import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createCssVars, clsx, assignInlineCssVars } from "@creditornot/cb-utils";
import "./style.css";
const cssVars = createCssVars(["color", "size"]);
const root = "cb_Spinner_root_rpin";
const animationContainer = "cb_Spinner_animationContainer_a1x9";
const circle = "cb_Spinner_circle_c3ni";
const container1 = "cb_Spinner_container1_c158";
const container2 = "cb_Spinner_container2_c1m1";
const container3 = "cb_Spinner_container3_cd02";
const Spinner = forwardRef(({
  className,
  color: color2 = "blue",
  size,
  style,
  styleParams,
  ...rest
}, ref) => {
  return /* @__PURE__ */ jsx("div", {
    className: clsx(root, className),
    "data-color": color2,
    "data-size": size,
    ...rest,
    ref,
    style: styleParams ? {
      ...style,
      ...assignInlineCssVars(cssVars, styleParams)
    } : style,
    children: /* @__PURE__ */ jsxs("div", {
      className: animationContainer,
      children: [/* @__PURE__ */ jsx("div", {
        className: clsx(circle, container1),
        children: /* @__PURE__ */ jsx("svg", {
          viewBox: "0 0 50 50",
          children: /* @__PURE__ */ jsx("circle", {
            cx: "25",
            cy: "25",
            fill: "none",
            r: "20",
            strokeWidth: "5"
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: clsx(circle, container2),
        children: /* @__PURE__ */ jsx("svg", {
          viewBox: "0 0 50 50",
          children: /* @__PURE__ */ jsx("circle", {
            cx: "25",
            cy: "25",
            fill: "none",
            r: "20",
            strokeWidth: "5"
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: clsx(circle, container3),
        children: /* @__PURE__ */ jsx("svg", {
          viewBox: "0 0 50 50",
          children: /* @__PURE__ */ jsx("circle", {
            cx: "25",
            cy: "25",
            fill: "none",
            r: "20",
            strokeWidth: "5"
          })
        })
      })]
    })
  });
});
Spinner.displayName = "Spinner";
export {
  Spinner
};
//# sourceMappingURL=index.js.map
